// extracted by mini-css-extract-plugin
export default {"container":"op-z","ratingLayout":"pp-z","ratingLabel":"qp-z","nonInteractiveRatingLabel":"rp-z"};